<ng-template #capaPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeCapaPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ selectedTabName }}</label>
    </div>
    <div class="mat-tab-container">
        <mat-tab-group class="mat-tab-container mat-elevation-z4" (selectedTabChange)="onTabClick($event)">
            <mat-tab label="Create CAPA" style="margin: 3px;">
                <div class="row">
                    <div class="col-md-3">
                        <div>
                            <label id="group" for="email">Group</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="group" (closed)="groupSearchText=''"
                            (click)="focusSearch('focus-group')" (keydown.enter)="focusSearch('focus-group')">
                            <input type="search" id="focus-group" class="dropdownsearchstyle"
                                [(ngModel)]="groupSearchText" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null"
                                (onSelectionChange)="onGroupSelect($event,null)">Un-select</mat-option>
                            <mat-option *ngFor="let item of groupDropDown| assessmentSearch :groupSearchText"
                                [value]="item.valueExp" (onSelectionChange)="onGroupSelect($event,item)">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <ng-container *ngIf="groupDetails  && dynamicLabel">
                        <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable=='Y'">
                            <div>
                                <label id="department" for="email">{{dynamicLabel['DEPT_NAME'].fieldName}}</label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
                                    [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                                </span>
                            </div>
                            <mat-select matInput placeholder="Select" [(ngModel)]="capa.deptCode"
                                (closed)="departmentSearchText=''" (click)="focusSearch('focus-department')"
                                (keydown.enter)="focusSearch('focus-department')">
                                <input type="search" id="focus-department" class="dropdownsearchstyle"
                                    [(ngModel)]="departmentSearchText" matInput placeholder="search">
                                <mat-option class="unselectStyle" (onSelectionChange)="onDepartmentSelect($event,null)"
                                    [value]="null">Un-select</mat-option>
                                <mat-option
                                    *ngFor="let item of departmentDropDown | assessmentSearch :departmentSearchText"
                                    (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-md-3" id="search-container">
                            <div>
                                <label id="owner" for="email">{{dynamicLabel['OWNER_USER_NAME'].fieldName}}</label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME'].fieldNotes"
                                    [matTooltip]="dynamicLabel['OWNER_USER_NAME'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                                </span>
                            </div>
                            <mat-select matInput placeholder="Select" [(ngModel)]="capa.owner"
                                (closed)="ownerSearchText=''" (click)="focusSearch('focus-owner')"
                                (keydown.enter)="focusSearch('focus-owner')">
                                <input type="search" id="focus-owner" class="dropdownsearchstyle"
                                    [(ngModel)]="ownerSearchText" matInput placeholder="search">
                                <mat-option class="unselectStyle" [value]="null"
                                    (onSelectionChange)="onOwnerSelect($event,null)">Un-select</mat-option>
                                <mat-option *ngFor="let item of ownerDropDown| assessmentSearch :ownerSearchText"
                                    (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-md-3">
                            <div>
                                <label id="type" for="email">{{dynamicLabel['CAPA_TYPE'].fieldName}}</label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['CAPA_TYPE'].fieldNotes"
                                    [matTooltip]="dynamicLabel['CAPA_TYPE'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                                </span>
                            </div>
                            <mat-select matInput placeholder="Select" [(ngModel)]="capa.capaType"
                                (closed)="typeSearchText=''" (click)="focusSearch('focus-type')"
                                (keydown.enter)="focusSearch('focus-type')">
                                <input type="search" id="focus-type" class="dropdownsearchstyle"
                                    [(ngModel)]="typeSearchText" matInput placeholder="search">
                                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                                <mat-option *ngFor="let item of typeDropDown| assessmentSearch :typeSearchText"
                                    (onSelectionChange)="onCapaTypeSelect($event,item)" [value]="item.valueExp">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-md-3">
                            <div>
                                <label id="requested-at" for="email">
                                    {{dynamicLabel['REQUESTED_AT'].fieldName}}</label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
                                    [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                                </span>
                            </div>
                            <mat-select matInput placeholder="Select" [(ngModel)]="capa.requestedAt"
                                (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested-at')"
                                (keydown.enter)="focusSearch('focus-requested-at')">
                                <input type="search" id="focus-requested-at" class="dropdownsearchstyle"
                                    [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                                <mat-option
                                    *ngFor="let item of requestedAtDropDown| assessmentSearch :requestedAtSearchText"
                                    (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-md-6" *ngIf="capa.requestedAt">
                            <div>
                                <label id="business-area" for="email">
                                    {{this.businessAreaName}} Area
                                </label>
                                <span class="mandatory-symbol">*</span>
                            </div>
                            <mat-select matInput multiple #businessArea placeholder="Select"
                                *ngIf="businessAreaDropDown.length" [(ngModel)]="selectedBusinessArea"
                                (closed)="businessAreaSearchText=''" (click)="focusSearch('focus-business-area')"
                                (keydown.enter)="focusSearch('focus-business-area')">
                                <input type="search" id="focus-business-area" class="dropdownsearchstyle"
                                    [(ngModel)]="businessAreaSearchText" matInput placeholder="search">
                                <div class="select-all">
                                    <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected"
                                        (change)="toggleAllSelection('businessArea')">Select
                                        All</mat-checkbox>
                                </div>
                                <mat-option
                                    *ngFor="let item1 of businessAreaDropDown| multiAssessmentSearchPipe :businessAreaSearchText"
                                    [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                                    {{ item1.displayExp }}
                                </mat-option>
                            </mat-select>
                            <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                                *ngIf="!businessAreaDropDown.length" [(ngModel)]="capa.coreBusinessAreaName"
                                (input)="limitCharacters($event, 'REQUESTED_AT')"></textarea>
                        </div>

                        <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable=='Y'">
                            <div>
                                <label id="expected-started-on" for="email">
                                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
                                </label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
                                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                                </span>
                            </div>
                            <input type="text" class="form-control data-picker-continer" bsDatepicker
                                [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
                                [(ngModel)]="capa.expectedToBeStartedOn"
                                (ngModelChange)="onExpectedToBeStartedOnChange()">
                        </div>

                        <div class="col-md-3">
                            <div>
                                <label id="expected-closure-on" for="email">
                                    {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
                                </label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
                                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"><img
                                        [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                            </div>
                            <input type="text" class="form-control data-picker-continer" bsDatepicker
                                [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                                [(ngModel)]="capa.expcetedClosureOn">
                        </div>

                        <div class="col-md-3" *ngIf="groupDetails.effectivenessCheckEnabled=='Y'">
                            <div>
                                <label for="email ">{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}</label>
                                <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"
                                    [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                                </span>
                            </div>
                            <mat-slide-toggle color="primary" name="ec" [(ngModel)]="capa.effectivenessCheckReqd">
                                <ng-container *ngIf="capa.effectivenessCheckReqd; else no">
                                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                                </ng-container>
                                <ng-template #no>
                                    <span style="color: red;">No</span>
                                </ng-template>
                            </mat-slide-toggle>
                        </div>

                        <div class="col-md-6">
                            <div>
                                <label id="short-description"
                                    for="email">{{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
                                    <span class="mandatory-symbol">*</span>
                                </label>
                                <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
                                    [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"><img
                                        [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                            </div>
                            <input class="input-filed-continers" type="text" [(ngModel)]="capa.shortDescription"
                                maxlength="100">
                        </div>

                        <div class="col-md-6">
                            <div>
                                <label id="description"
                                    for="email">{{dynamicLabel['CAPA_DESCRIPTION'].fieldName}}</label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['CAPA_DESCRIPTION'].fieldNotes"
                                    [matTooltip]="dynamicLabel['CAPA_DESCRIPTION'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                            </div>
                            <div class="hideToolbar">
                                <div class="row">
                                    <div class="hideToolbar col-sm-11">
                                        <st-editor [(ngModel)]="capa.capaDescription" [config]="excludeButtons"
                                            [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
                                    </div>
                                    <div class="col-sm-1 angular-editor-edit">
                                        <i class="far fa-edit" (click)="openEditor('CAPA Description')"
                                            (keydown.enter)="openEditor('CAPA Description')"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6" [hidden]="dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable=='Y'">
                            <div>
                                <label id="reason-for-capa" for="email">
                                    {{dynamicLabel['REASON_FOR_CAPA_CODE'].fieldName}}
                                </label>
                                <span class="mandatory-symbol">*</span>
                                <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_CAPA_CODE'].fieldNotes"
                                    [matTooltip]="dynamicLabel['REASON_FOR_CAPA_CODE'].fieldNotes">
                                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                            </div>
                            <mat-select matInput multiple #reasonForCapa placeholder="Select"
                                [(ngModel)]="selectedReasonForCapa" (closed)="reasonForCapaSearchText=''"
                                (click)="focusSearch('focus-reason')" (keydown.enter)="focusSearch('focus-reason')">
                                <input type="search" id="focus-reason" class="dropdownsearchstyle"
                                    [(ngModel)]="reasonForCapaSearchText" matInput placeholder="search">
                                <div class="select-all">
                                    <mat-checkbox [(ngModel)]="isAllCapaReasonSelected"
                                        (change)="toggleAllSelection('reasonForCapa')">Select
                                        All</mat-checkbox>
                                </div>
                                <mat-option
                                    *ngFor="let item1 of reasonForCapaDropDown | multiAssessmentSearchPipe :reasonForCapaSearchText"
                                    [value]="item1.valueExp" (onSelectionChange)="onReasonForCapaSelect($event,item1)">
                                    {{ item1.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-md-6"
                            *ngIf="visibleReasonForCapaIfOthers && dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable != 'Y'">
                            <div>
                                <label id="visible-if-others" for="email">
                                    {{dynamicLabel['REASON_FOR_CAPA_CODE'].fieldName}} if Others
                                </label>
                                <span class="mandatory-symbol">*</span>
                            </div>
                            <textarea id="reasonForChangeIfOthers" type="text" class="input-filed-textarea" rows="4"
                                cols="50" [(ngModel)]="capa.reasonForCapa"></textarea>
                        </div>

                        <div class="col-md-2" *ngIf="groupDetails.isRiskCalculationReqd=='Y'">
                            <div><label for="email">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
                                <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
                                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"><img
                                        [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                            </div>

                            <mat-slide-toggle color="primary" name="ec" [(ngModel)]="capa.isRiskCalculationReqd">
                                <ng-container *ngIf="capa.isRiskCalculationReqd; else no">
                                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                                </ng-container>
                                <ng-template #no>
                                    <span style="color: red;">No</span>
                                </ng-template>
                            </mat-slide-toggle>
                        </div>

                        <div class="form-template ActivityPage" id="Additionaldetail" *ngIf="refresh">
                            <app-flexible-fields #flexible [from]="'Dependency'"
                                [dependency]="dependency"></app-flexible-fields>
                        </div>
                    </ng-container>
                </div>
            </mat-tab>
            <mat-tab label="Map CAPA">
                <div class="row">
                    <div class="col-md-3">
                        <div><label id="group-validation" for="email">Group</label><span
                                class="mandatory-symbol">*</span></div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="group" (closed)="groupSearchText=''"
                            (click)="focusSearch('focus-map-group')" (keydown.enter)="focusSearch('focus-map-group')">
                            <input type="search" id="focus-map-group" class="dropdownsearchstyle"
                                [(ngModel)]="groupSearchText" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                            <mat-option *ngFor="let item of groupDropDown| assessmentSearch :groupSearchText"
                                [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-3">
                        <div><label for="email">Department</label></div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="department"
                            (closed)="departmentSearchText=''" (click)="focusSearch('focus-map-department')"
                            (keydown.enter)="focusSearch('focus-map-department')">
                            <input type="search" id="focus-map-department" class="dropdownsearchstyle"
                                [(ngModel)]="departmentSearchText" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                            <mat-option *ngFor="let item of departmentDropDown| assessmentSearch :departmentSearchText"
                                [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="row">
                    <div class="search-button-continer btn-align" mat-dialog-actions>
                        <button mat-stroked-button class="searchButton" (click)="searchCapa()">
                            <i class="fa-solid fa-magnifying-glass"></i> Search
                        </button>
                        <button mat-stroked-button class="cancelButton" (click)="reset()">
                            <i class="fa fa-repeat"></i> Reset
                        </button>
                    </div>
                </div>
                <div class="table-container" *ngIf="capaDetails.length">
                    <table style="height: 46vh;">
                        <thead>
                            <th style="min-width: 80px; text-align: center;">
                                <div style="display: flex;">
                                    <div>
                                        <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                                    </div>
                                    <div style="margin-left: 5px;">
                                    </div>
                                </div>
                            </th>
                            <th> <span>CAPA No.</span></th>
                            <th> <span>Dept Name</span></th>
                            <th> <span>Owner</span></th>
                            <th> <span>Short Description</span></th>
                            <th id="menu" class="sticky-col first-col"></th>
                        </thead>
                        <tbody>
                            <tr class="data-row-container" *ngFor="let capa of capaDetails; let idx = index;"
                                [class.highlightRow]="capa.childCheckBox">
                                <td style="min-width: 80px; text-align: center;">
                                    <div style="display: flex;">
                                        <div [ngClass]="capa.childCheckBox ?'static_icon':'hover-menu-icons'">
                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                        </div>
                                        <div style="margin-left: 5px;">
                                            <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                                                [checked]="capa.childCheckBox"
                                                (change)="onChildChecked($event, capa, idx)">
                                        </div>
                                    </div>
                                </td>
                                <td class="row-data">{{ capa.capaId }}</td>
                                <td class="row-data">{{ capa.deptName }}</td>
                                <td class="row-data">{{ capa.ownerUserName }}</td>
                                <td class="row-data">{{ capa.shortDescription }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions
        *ngIf="selectedTabName == 'Create CAPA' ||( selectedTabName != 'Create CAPA' && capaDetails.length)">
        <button mat-stroked-button class="addButton" [disabled]="selectedTabName != 'Create CAPA' && !pickedCapaDetails"
            (click)="createCapa(capa)">
            <i class="fas fa-check"></i> Add
        </button>
        <button mat-stroked-button class="cancelButton" (click)="closeCapaPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #angularEditor>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelEditor()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ editorTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div><br>
    <div class="row">
        <div class="col-md-12 st-editor">
            <st-editor [(ngModel)]="editorValue" [config]="includeButtons" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="okAngularEditorData(editorValue)">
            <i class="fas fa-check"></i> Save
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #mandatoryPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Mandatory Alert </label>
    </div>

    <div style="margin: 15px 15px;">
        <div style="display: flex; justify-content: center; align-items: center;">
            <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
                <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
            </span>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
                Ok
            </button>
        </div>
    </div>
</ng-template>